// 申込取消時の兄弟割引アラート対象：同一世帯（row.siblingIds・API が同一メールの参加者から算出）で
// 参加中かつ確定時スナップショットが兄弟料金の方。取消後も料金は申込時のまま変わらない旨を知らせる。
export const siblingCancelTargets = (row, list) => {
  if (!row) return [];
  const ids = row.siblingIds || [];
  return list.filter((r) => ids.includes(r.id) && r.tab === "attend" && r.feeCategory === "sibling");
};
